// extracted by mini-css-extract-plugin
export var checkbox = "EmbedChoices-module--checkbox--4843f";
export var checked = "EmbedChoices-module--checked--d194d";
export var choice = "EmbedChoices-module--choice--35f3b";
export var container = "EmbedChoices-module--container--086ee";
export var description = "EmbedChoices-module--description--1951a";
export var title = "EmbedChoices-module--title--db64a";